import { render, staticRenderFns } from "./product-alerts.vue?vue&type=template&id=2e50672e&scoped=true"
import script from "./product-alerts.vue?vue&type=script&lang=js"
export * from "./product-alerts.vue?vue&type=script&lang=js"
import style0 from "./product-alerts.vue?vue&type=style&index=0&id=2e50672e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50672e",
  null
  
)

export default component.exports